// fisiohome-backend's StopOrderRequest.stop_reason, in its order.
export const STOP_REASONS = [
	"PATIENT_DECEASED",
	"PATIENT_REQUEST",
	"OTHER",
] as const;
export type StopReason = (typeof STOP_REASONS)[number];

export const NOTES_MAX = 1000;

export interface StopForm {
	reason: StopReason | "";
	notes: string;
	billed: string;
}

// The first rule the form breaks, as a stop_package_dialog.errors key, or null.
export function stopFormError(form: StopForm, totalAmount: number) {
	if (!form.reason) return "reason_required";
	if (form.reason === "OTHER" && !form.notes.trim()) return "notes_required";
	if (form.billed.trim() === "") return "billed_required";
	const billed = Number(form.billed);
	if (!Number.isFinite(billed) || billed < 0 || billed > totalAmount)
		return "billed_out_of_range";
	return null;
}

export type StopFormError = NonNullable<ReturnType<typeof stopFormError>>;

// Which field each rule belongs to, so its message sits under that field.
export const STOP_FORM_ERROR_FIELD: Record<StopFormError, keyof StopForm> = {
	reason_required: "reason",
	notes_required: "notes",
	billed_required: "billed",
	billed_out_of_range: "billed",
};
